export default __webpack_public_path__ + "static/loans-535525f11615b5ccd0c6459d9c0ddff9.png";